<template>
    <div>
        <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" class="mr-2" v-on="on">mdi-dots-vertical</v-icon>
            </template>
            <v-list class="py-0">
                <span v-for="(item, i) in items" :key="i">
                    <v-list-item v-if="!item.passOnly || user.permissions.pass" class="item" @click="vereinsAction(item)">
                        <v-list-item-icon class="mr-3">
                            <v-icon>{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="pr-3">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </span>
            </v-list>
        </v-menu>
        <spieler-export-dialog param="downloadVereinSpieler" :vereins-id="vereinId" level="verein"/>
    </div>
</template>

<script>
    import RouterServices from "@/utilities/services/router/routerServices";
    import SpielerExportDialog from "@/views/spielerExport/spielerExportDialog";

    export default {
        name: "verein-edit-menu",
        components: {SpielerExportDialog},
        props: ['id', 'lvId'],
        computed: {
            user(){ return this.$store.state.user },
            vereinId(){ return this.lvId + this.id},
            items(){
                return [
                    { title: 'Spieler herunterladen', icon: 'mdi-account-arrow-down', action: 'download', passOnly: false },
                    { title: this.user.permissions.pass ? 'Vereinsdaten ändern': 'Vereinsdaten anzeigen',
                      icon: this.user.permissions.pass ? 'mdi-pencil': 'mdi-information', action: 'edit', passOnly: false },
                    { title: 'Vereinsdatenblatt', icon: 'mdi-information', action: 'datenblatt', passOnly: false },
                    { title: 'Verein löschen', icon: 'mdi-trash-can-outline', action: 'delete', passOnly: true },
                ]
            }
        },
        methods: {
            vereinsAction(item){
                if ( item.action === 'download') {
                    this.openDownloadWindow()
                    return
                }
                if ( item.action === 'datenblatt') {
                    RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'datenblatt', 'true' )
                }
                this.$emit('vereinsAction', item.action);
            },
            openDownloadWindow(){
                RouterServices.pushRouteQueryParameter(this.$router, this.$route, 'downloadVereinSpieler', 'true' )
            }
        },
    }
</script>

<style scoped>
    .item:hover {background-color: #f2f2f2}
</style>